module.exports = __webpack_public_path__ + "img/cloudy.e2a52e55.png";